<template>
  <div>
    <div class="com-header">
      <div
        class="custom-row custom-options-menu justify-content-between align-items-center"
      >
        <div class="customHeading">
          <nav>
            <div
              class="nav nav-tabs custom-nav-tabs"
              id="nav-tab"
              role="tablist"
            >
              <a
                class="nav-item nav-link custom-nav-link active"
                id="nav-table-tab"
                data-toggle="tab"
                href="#nav-table"
                role="tab"
                aria-controls="nav-table"
                aria-selected="true"
              >
                <span> {{ moduleName }} </span>
              </a>
            </div>
          </nav>
        </div>
        <div class="">
          <div class="custom-icons-group">
            <div class="custom-row w3-center custom-filter-section no-gutters">
              <div
                class="custom-btn pl-2"
                data-toggle="tooltip"
                data-placement="top"
                title="View Details"
              >
                <b-btn @click="$bvModal.show('InvoiceShipmentsModal')">
                  <div class="icon">
                    <b-icon icon="chevron-double-right" scale="0.8"></b-icon>
                    View Details
                  </div>
                </b-btn>
              </div>
              <div
                class="custom-btn pl-2"
                data-toggle="tooltip"
                data-placement="top"
                title="Download to Excel"
              >
                <a @click="downloadExcel()">
                  <div class="icon">
                    <b-icon icon="download" scale="1.3"></b-icon>
                  </div>
                </a>
              </div>
              <div
                class="custom-btn pl-2"
                data-toggle="tooltip"
                data-placement="top"
                title="Filters"
              >
                <a
                  href="#filterSection"
                  data-toggle="collapse"
                  role="button"
                  aria-expanded="false"
                  aria-controls="filterSection"
                >
                  <div class="icon">
                    <b-icon icon="filter" scale="1.6"></b-icon>
                  </div>
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="collapse" id="filterSection">
        <div class="card card-body custom-filter-body">
          <div class="custom-filter-wrap">
            <div
              class="container-fluid custom-row d-flex  justify-content-center"
            >
              <div class="custom-filter-column ml-2">
                <b-form>
                  <b-form-group
                    label=""
                    label-for="datepicker-1"
                    autocomplete="off"
                  >
                    <b-form-datepicker
                      id="datepicker-1"
                      v-model="StartDate"
                      placeholder="Choose Start Date"
                      local="en"
                      @input="getShipmentReport()"
                      required
                    ></b-form-datepicker>
                  </b-form-group>
                </b-form>
              </div>

              <div class="custom-filter-column ml-2">
                <b-form>
                  <b-form-group
                    label=""
                    label-for="datepicker-2"
                    autocomplete="off"
                  >
                    <b-form-datepicker
                      id="datepicker-2"
                      v-model="EndDate"
                      placeholder="Choose End Date"
                      local="en"
                      @input="getShipmentReport()"
                      required
                    ></b-form-datepicker>
                  </b-form-group>
                </b-form>
              </div>

              <div class="custom-filter-column ml-2">
                <b-form>
                  <b-form-group label="" label-for="Client" autocomplete="off">
                    <b-form-select
                      v-model="SelectedProductId"
                      :options="products"
                      value-field="id"
                      text-field="name"
                      @change="getShipmentReport()"
                    >
                      <b-form-select-option :value="0"
                        >All Products</b-form-select-option
                      >
                    </b-form-select>
                  </b-form-group>
                </b-form>
              </div>

              <div class="custom-filter-column ml-2">
                <b-form>
                  <b-form-group label="" label-for="Client" autocomplete="off">
                    <b-form-select
                      v-model="SelectedClientId"
                      :options="clients"
                      value-field="id"
                      text-field="companyName"
                      @change="getShipmentReport()"
                    >
                      <b-form-select-option :value="0"
                        >All Clients</b-form-select-option
                      >
                    </b-form-select>
                  </b-form-group>
                </b-form>
              </div>

              <!-- <div class="custom-filter-column">
                <b-form>
                  <b-form-group
                    label=""
                    label-for="isInventory"
                    autocomplete="off"
                  >
                    <b-form-select
                      id="isinventory"
                      v-model="IsInventory"
                      :options="inventoryOptions"
                      class="class-dropdown"
                      @change="getShipmentReport()"
                    ></b-form-select>
                  </b-form-group>
                </b-form>
              </div> -->
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="custom-accordion-separator">
      <div class="custom-separator"></div>
    </div>

    <div>
      <div class="row">
        <div class="col">
          <div class="table-responsive">
            <table
              id="tblPrivate"
              class="table table-striped table-borderless cutom-table table-striped table-sm"
              style="font-size: 85%;"
            >
              <thead>
                <tr>
                  <th role="columnheader">&nbsp;</th>
                  <th v-for="weight in weights" :key="weight.id">
                    {{ weight.weight }}
                  </th>
                  <th role="columnheader">Total</th>
                </tr>
              </thead>
              <tbody>
                <tr
                  v-if="productionData == null || productionEntries.length == 0"
                >
                  <td colspan="8" class="center-td">No Data</td>
                </tr>

                <tr
                  v-else
                  v-for="rec in productionEntries"
                  :key="rec.flourTypeId"
                >
                  <td role="cell" class="report-first-td">
                    {{ rec.flourTypeName }}
                  </td>
                  <td
                    role="cell"
                    v-for="item in rec.productionDetails"
                    :key="item.flourWeightTypeLinkId"
                  >
                    <span v-if="item.noOfSacks > 0 || item.kGs > 0">
                      {{ item.noOfSacks }} &nbsp;Sacks {{ item.kGs }} &nbsp;KGs
                      {{ item.tons }} &nbsp;TONs
                    </span>
                    <span v-else>-</span>
                  </td>
                  <td>
                    {{ rec.totalKGs }}&nbsp;KGs {{ rec.totalTons }}&nbsp;TONs
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>

      <!--PAGINATION START-->
      <div class="row justify-content-between align-items-center pagination">
        <div class="col-md-2">
          <div class="showPages">
            <select
              class="form-control"
              id="selClass"
              v-model="perPage"
              @change="getShipmentReport()"
            >
              <option
                v-for="option in options"
                :key="option.value"
                :value="option.value"
              >
                {{ option.text }}
              </option>
            </select>
          </div>
        </div>

        <div class="col-md-8 d-flex justify-content-center">
          <div class="overflow-auto">
            <b-pagination
              v-model="page"
              :total-rows="rows"
              :per-page="perPage"
              first-text="First"
              prev-text="Prev"
              next-text="Next"
              last-text="Last"
              @change="getPage"
            ></b-pagination>
          </div>
        </div>

        <div class="col-md-2">
          <input
            class="form-control search-box page-no-search"
            type="text"
            v-bind:placeholder="page"
            aria-label="search"
            v-model.number="pageNumOnSearch"
            style="height:38px"
          />

          <button
            class="search-button btn btn-primary search page-no-search-btn"
            @click="search()"
          >
            GO
          </button>
        </div>
      </div>
      <!--/PAGINATION END-->
      <!--SPINNER-->
      <Spinner
        v-if="isLoading"
        message="Loading..."
        size="medium"
        line-fg-color="rgb(222 224 219"
        line-bg-color="rgb(68 66 62)"
      >
      </Spinner>
      <!--/SPINNER-->

      <InvoiceShipmentsModal v-if="details!=null" :shipmentDetails="details" />
    </div>
  </div>
</template>

<script>
import axios from "axios";
import Spinner from "vue-simple-spinner";
import XLSX from "xlsx";
import { saveAs } from "file-saver";
import InvoiceShipmentsModal from "./modal/InvoiceShipmentsModal.vue";

export default {
  name: "ShipmentReportPrivate",
  data() {
    return {
      moduleName: "Private Shipment Report",
      isLoading: false,

      inventoryOptions: [
        { value: true, text: "Inventory" },
        { value: false, text: "Non Inventory" },
        { value: null, text: "Transactions (All)" },
      ],
      IsInventory: null,

      StartDate: new Date(),
      EndDate: new Date(),
      productionData: null,
      productionEntries: null,
      weights: null,
      pageNumOnSearch: "",
      filteredText: "",
      rows: 0,
      page: 1,
      options: [
        { text: "Show 2", value: 2 },
        { text: "Show 10", value: 10 },
        { text: "Show 25", value: 25 },
        { text: "Show 50", value: 50 },
        { text: "Show 100", value: 100 },
      ],
      perPage: 25,
      clients: [],
      products: [],
      SelectedClientId: 0,
      SelectedProductId: 0,
      details: null,
    };
  },

  methods: {
    getPage(page) {
      this.page = page;
      this.getShipmentReport();
    },

    getShipmentReport() {
      this.isLoading = true;
      axios
        .post("/productionreport/GetAllPrivateShipments", {
          UserId: this.$auth.user().id,
          CompanyId: this.$auth.user().companyId,
          PageSize: this.perPage,
          Page: this.page,
          FromDate: this.StartDate,
          ToDate: this.EndDate,
          IsInventory: this.IsInventory,
          ClientId: this.SelectedClientId === 0 ? null : this.SelectedClientId,
          FlourTypeId:
            this.SelectedProductId === 0 ? null : this.SelectedProductId,
        })
        .then((res) => {
          console.log(res.data);
          if (res.data.status == 1) {
            // console.log(res.data)
            this.productionData = res.data.data;
            this.weights = this.productionData.flourWeights;
            this.productionEntries = this.productionData.records;
            this.details = this.productionData.details;
            this.rows = res.data.totalRecords;
          } else if (res.data.status == 0) {
            this.productionData = null;
          } else if (res.data.status == -1) {
            this.$bvModal.msgBoxOk(res.data.msg, {
              title: "Error",
              size: "sm",
              buttonSize: "sm",
              okVariant: "danger",
              headerClass: "p-10 border-bottom-0",
              footerClass: "p-2 border-top-0",
              centered: true,
            });
          }
          this.isLoading = false;
        });
    },

    getClients() {
      let model = {
        CompanyId: this.$auth.user().companyId,
      };
      axios.post("/Client/GetAllClients", model).then((res) => {
        console.log(res.data);
        this.clients = res.data.data;
      });
    },

    getProducts() {
      let model = {
        CompanyId: this.$auth.user().companyId,
      };
      axios.post("/FlourType/GetAllFlourTypes", model).then((res) => {
        console.log(res.data);
        this.products = res.data.data;
      });
    },

    search() {
      this.page = this.pageNumOnSearch;
      this.getShipmentReport();
    },

    print() {
      window.print();
    },

    downloadExcel() {
      console.log("Download excel file from table");
      console.log(document.getElementById("tblPrivate"));
      //workbook object will be created with the table inside
      var wb = XLSX.utils.table_to_book(document.getElementById("tblPrivate"), {
        sheet: "Sheet JS",
      });
      /*wb['!cols'][141] = { hidden: true };*/

      delete wb["141"];
      console.log(wb);
      //export it as downloadable xlsx file
      //convert into binary
      var wbout = XLSX.write(wb, {
        bookType: "xlsx",
        bookSST: true,
        type: "binary",
      });

      saveAs(
        new Blob([this.s2ab(wbout)], { type: "application/octet-stream" }),
        "PrivateShipmentReport.xlsx"
      );
    },

    s2ab(s) {
      var buf = new ArrayBuffer(s.length);
      var view = new Uint8Array(buf);
      for (var i = 0; i < s.length; i++) view[i] = s.charCodeAt(i) & 0xff;
      return buf;
    },

    viewDetails() {},
  },
  created() {
    var date = new Date();
    this.StartDate = new Date(
      date.getFullYear(),
      date.getMonth(),
      1,
      this.StartDate.getHours()
    );
    // console.log(this.StartDate)
    // this.StartDate.setFullYear(date.getFullYear(), date.getMonth(), 1)
    this.EndDate = new Date(
      date.getFullYear(),
      date.getMonth() + 1,
      0,
      this.EndDate.getHours()
    );
    // console.log(this.EndDate)
    // this.EndDate.setFullYear(date.getFullYear(), date.getMonth() + 1, 0);

    this.getShipmentReport();
    this.getClients();
    this.getProducts();
    // this.getStudents();
    //localStorage.setItem("mytime", Date.now());
  },
  components: {
    Spinner, InvoiceShipmentsModal,
  },
};
</script>

<style scoped>
button.page-link {
  display: inline-block;
}
button.page-link {
  font-size: 20px;
  color: #29b3ed;
  font-weight: 500;
}
.offset {
  width: 500px !important;
  margin: 20px auto;
}
select#class-dropdown {
  width: 80%;
  margin-left: 16%;
}
.form-group {
  margin-bottom: 0.2rem;
}
@media print {
  .com-header,
  .pagination {
    display: none;
  }
  .table {
    border: 1px solid #e7e1e1 !important;
  }
}
a {
  cursor: pointer;
}
</style>
